import { useEffect } from 'react';

export function usePageTitle(suffix?: string) {
  useEffect(() => {
    document.title = 'Magic Fam Concierge' + (suffix ? ` - ${suffix}` : '');
  }, [suffix]);
}
